import {
  BsActivity,
  BsChatLeftDots,
  BsClipboardData,
  BsCurrencyDollar,
  BsGear,
  BsHouseDoor,
  BsInfoCircle,
  BsJournalText,
  BsListCheck,
} from 'react-icons/bs';
import { showUsaFeature, showWorklistFeature } from 'utils/app';
import { DEFAULT_ICON_SIZE } from './general';

export interface NavLinkItem {
  link: string;
  label: string;
  leftIcon: React.ReactNode;
  hideOnNavbar?: boolean;
}

export const mainData: NavLinkItem[] = [
  { link: 'dashboard', label: 'navbar_dashboard', leftIcon: <BsHouseDoor size={DEFAULT_ICON_SIZE} /> },
  {
    link: 'worklist',
    label: 'navbar_worklist',
    leftIcon: <BsListCheck size={DEFAULT_ICON_SIZE} />,
    hideOnNavbar: !showWorklistFeature,
  },
  { link: 'patients', label: 'navbar_patients', leftIcon: <BsActivity size={DEFAULT_ICON_SIZE} /> },
  { link: 'reports', label: 'navbar_reports', leftIcon: <BsClipboardData size={DEFAULT_ICON_SIZE} /> },
  {
    link: 'billing',
    label: 'navbar_billing',
    leftIcon: <BsCurrencyDollar size={DEFAULT_ICON_SIZE} />,
    hideOnNavbar: !showUsaFeature,
  },
  { link: 'settings', label: 'navbar_settings', leftIcon: <BsGear size={DEFAULT_ICON_SIZE} /> },
  { link: 'feedback', label: 'navbar_feedback', leftIcon: <BsChatLeftDots size={DEFAULT_ICON_SIZE} /> },
  { link: 'about', label: 'navbar_about', leftIcon: <BsInfoCircle size={DEFAULT_ICON_SIZE} /> },
];

export const supportData: NavLinkItem[] = [
  {
    link: 'https://docs.fibricheck.com/supportguide/6JFUYhLhFCWX2v38fLXE',
    label: 'navbar_support_guide',
    leftIcon: <BsJournalText size={DEFAULT_ICON_SIZE} />,
    hideOnNavbar: showUsaFeature,
  },
];
